import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Router, RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {PlatformNotificationService} from '../services/platform-notification.service';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzTableModule} from 'ng-zorro-antd/table';
import {NzTagModule} from 'ng-zorro-antd/tag';

@Component({
  selector: 'app-admin-notifications',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, TranslateModule, NzButtonModule, NzCardModule, NzTableModule, NzTagModule],
  styles: [':host { display: block; min-width: 0; } nz-card { display: block; width: 100%; max-width: 100%; box-sizing: border-box; }'], template: `
    <nz-card [nzTitle]="'ADMIN.NOTIFICATIONS.TITLE'|translate" [nzExtra]="newButton"><ng-template #newButton><button nz-button nzType="primary" routerLink="/admin/notifications/new">{{ 'ADMIN.NOTIFICATIONS.NEW'|translate }}</button></ng-template>
      <p *ngIf="error">{{ 'ADMIN.NOTIFICATIONS.ERROR_LOAD'|translate }}</p><p *ngIf="!loading && !items.length">{{ 'ADMIN.NOTIFICATIONS.EMPTY_HISTORY'|translate }}</p>
      <nz-table *ngIf="items.length" [nzData]="items" [nzLoading]="loading" [nzPageSize]="20">
      <thead><tr><th>{{'ADMIN.NOTIFICATIONS.SENT_AT'|translate}}</th><th>{{'ADMIN.NOTIFICATIONS.TITLE_PREVIEW'|translate}}</th><th>{{'ADMIN.NOTIFICATIONS.STATUS'|translate}}</th><th>{{'ADMIN.NOTIFICATIONS.SEVERITY'|translate}}</th><th>{{'ADMIN.NOTIFICATIONS.TARGET'|translate}}</th><th>{{'ADMIN.NOTIFICATIONS.RECIPIENT_COUNT'|translate}}</th><th>{{'ADMIN.NOTIFICATIONS.DETAIL'|translate}}</th></tr></thead><tbody>
        <tr *ngFor="let item of items">
          <td>{{ item.sentAt|date:'short' }}</td>
          <td>{{ item.content?.title?.en }}</td>
          <td><nz-tag>{{ ('ADMIN.NOTIFICATIONS.STATUS_' + item.status.toUpperCase())|translate }}</nz-tag><small>{{ 'ADMIN.NOTIFICATIONS.DELIVERY_SUMMARY' | translate:{created:item.createdCount, failed:item.failedCount} }}</small></td>
          <td><nz-tag>{{ ('ADMIN.NOTIFICATIONS.SEVERITY_' + item.severity.toUpperCase())|translate }}</nz-tag></td>
          <td>{{ item.target?.kind || '-' }}</td>
          <td>{{ item.recipientCount }}</td><td>
            <button nz-button (click)="open(item._id)">{{ 'ADMIN.NOTIFICATIONS.DETAIL'|translate }}</button>
          </td>
        </tr></tbody></nz-table><button *ngIf="nextCursor" nz-button (click)="load(nextCursor)">{{ 'ADMIN.NOTIFICATIONS.LOAD_MORE'|translate }}</button>
    </nz-card>`
})
export class AdminNotificationsComponent implements OnInit {
  items: any[] = [];
  nextCursor: string | null = null; loading = false; error = false;

  constructor(private service: PlatformNotificationService, private router: Router) {
  }

  ngOnInit() { this.load(); }
  load(cursor?: string | null) {
    this.loading = true; this.error = false;
    this.service.sends(cursor).subscribe({ next: (r: any) => { this.items = cursor ? [...this.items, ...(r.items || [])] : (r.items || []); this.nextCursor = r.nextCursor || null; this.loading = false; }, error: () => { this.error = true; this.loading = false; } });
  }

  open(id: string) {
    this.router.navigateByUrl('/admin/notifications/' + id)
  }
}
